import * as React from "react";
import { PrescriptionTable } from "./PrescriptionTable.js";
const PrescriptionTableContainer = ({
  orientation,
  prescription,
  name,
  size
}) => {
  return /* @__PURE__ */ React.createElement(
    PrescriptionTable,
    {
      orientation,
      prescription,
      "aria-label": name,
      size
    }
  );
};
export {
  PrescriptionTableContainer,
  PrescriptionTableContainer as default
};
//# sourceMappingURL=PrescriptionTableContainer.js.map
